import { MinimalVideoSkinElement } from '../../presets/video/minimal-skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/minimal-video/register';

safeDefine(MinimalVideoSkinElement);
